import controller from './controller';
import template from './template.html';
import styles from './styles.less';

routes.$inject = ['$stateProvider', '$urlRouterProvider'];

export default function routes($stateProvider, $urlRouterProvider){

	$stateProvider.state('signup', {
		url: '/signup',
		controllerAs: 'ctrl',
		controller: controller,
		template: template
	})


}


/** WEBPACK FOOTER **
 ** ./src/guest/signup/routes.js
 **/